/*
 * @Author: Nie Wei
 * @Date: 2018-05-15 15:39:58
 * @Last Modified by: Nie Wei
 * @Last Modified time: 2020-01-10 16:51:51
 * @Description echarts
 */

/**
 * 在
 * http://echarts.baidu.com/tutorial.html#%E5%9C%A8%20webpack%20%E4%B8%AD%E4%BD%BF%E7%94%A8%20ECharts
 * 进行 Echarts的按需引用，减少引用大小
 */

// import echarts from 'echarts'

// 需要修改成按需引用
const echart = require('echarts/lib/echarts')

require('echarts/lib/chart/line')
require('echarts/lib/chart/bar')
require('echarts/lib/chart/pie')
require('echarts/lib/component/title')
require('echarts/lib/component/tooltip')
require('echarts/lib/component/axisPointer')
require('echarts/lib/component/legend')
require('echarts/lib/component/axis')
require('echarts/lib/component/dataZoom')
require('echarts/lib/component/polar')
require('echarts/lib/chart/lines')
require('echarts/lib/chart/effectScatter')
require('echarts/lib/chart/map')
require('echarts/lib/component/visualMap')
require('echarts/lib/component/geo')

export default {
  install(Vue) {
    Vue.prototype.$echarts = echart
    Vue.echarts = echart
  },
}

// export const echarts = echart
